import { SharedService } from 'src/app/services/shared.service';
import { AccountService } from './../../../services/account.service';
import { ManagementHttpService } from './../../../http/management-http.service';
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { ProductHttpService } from 'src/app/http/product-http.service';
import { AlertComponent } from 'src/app/shared/alert/alert.component';
import { ConfirmModalComponent } from 'src/app/shared/modals/confirm-modal/confirm-modal.component';

@Component({
    selector: 'app-product-availability',
    templateUrl: './product-availability.component.html',
    styles: [],
})
export class ProductAvailabilityComponent implements OnInit {
    constructor(
        private activatedRoute: ActivatedRoute,
        private modalService: NgbModal,
        private managementHttpService: ManagementHttpService,
        public accountService: AccountService,
        public sharedService: SharedService,
        private fb: FormBuilder
    ) {}

    branchSelectForm = this.fb.group({
        branchId: [null],
    });

    availableState = this.fb.group({
        state: [null],
    });

    tempItems = [];

    items = [];

    totalItems = this.items.length;

    searchBoxControl = new FormControl();

    branches = [];

    branchId: string;

    @ViewChild('table') table: DatatableComponent;

    @ViewChild(AlertComponent) alert: AlertComponent;

    isSticky: boolean = false;

    branchBusy = false;

    ngOnInit(): void {
        this.routeData();
        this.initSubs();
    }

    initSubs() {
        this.branchSelectForm.valueChanges.subscribe((data1) => {
            this.branchBusy = true;
            this.managementHttpService.getProductAvailabilityState(data1.branchId).subscribe((data) => {
                this.items = data;
                this.tempItems = data;
                this.branchId = data1.branchId;
                this.branchBusy = false;
            });
        });
    }

    @HostListener('window:scroll', ['$event'])
    checkScroll() {
        this.isSticky = window.pageYOffset >= 158;
    }

    setSectionPosition(sectionId: number) {
        const id = `grouping-header-${sectionId}`;
        const yOffset = -132;
        const element = document.getElementById(id);
        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });
    }

    routeData() {
        this.activatedRoute.data.subscribe((data) => {
            this.items = data.data[0];
            this.tempItems = data.data[0];
            this.branches = data.data[1];
        });
    }

    tableFiltring(event: any) {
        const val = event.target.value.toLowerCase();
        const temp = this.tempItems.filter(function (d) {
            return d.productName.toLowerCase().indexOf(val) !== -1 || !val;
        });
        this.items = temp;
        this.table.offset = 0;
    }

    confirmState(productId: any, state: any) {
        let confirm = this.modalService.open(ConfirmModalComponent);
        confirm.componentInstance.headerLabel = 'Availability';
        confirm.componentInstance.messageLabel = 'Are you sure you want to change Availability if item?';
        confirm.result.then(
            (result) => {
                if (result === 'ok') {
                    this.updateAvailability(productId, state);
                }
            },
            () => {}
        );
    }

    updateAvailability(productId: any, state: any) {
        this.managementHttpService.updateProductAvailability(this.accountService.currentUser.branchId, productId, state).subscribe((data) => {});
    }

    updateItem(productId: any, state: any) {
        let item = this.tempItems.find((c) => c.productId === productId);
        if (
            state === 'unvailable' ||
            state === 'unAvailable till 1 hour' ||
            state === 'unAvailable till 2 hour' ||
            state === 'unAvailable till 4 hour' ||
            state === 'unAvailable till next day'
        ) {
            item.state = false;
        } else {
            item.state = true;
        }
        this.items = this.tempItems;
    }

    scrollSections(dir: string) {
        var section = document.getElementById('section-availity-list');
        if (dir === 'right') {
            section.scrollLeft += 160;
        } else {
            section.scrollLeft += -160;
        }
    }

    onCheckboxChange(e: any, row: any) {
        this.updateItem(row.productId, e.target.checked ? 'available' : 'unvailable');
        this.updateAvailability(row.productId, e.target.checked ? 'available' : 'unvailable');
    }
}
